// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .settings-title {
  border-bottom-width: 1px;
  border-bottom-style: solid;
  border-bottom-color: #cccccc;
  padding-bottom: 12px;
  font-weight: 700;
  font-size: 16px;
  margin-bottom: 0px;
}

.toolbar-container {
  border: 1px solid rgba(193, 190, 190, 0.49);
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

cxone-tabs {
  display: block;
  height: calc(100vh - 236px);
  /*border:1px solid #c1bebe;*/
  margin-top: 16px;
}

p-multiSelect {
  min-width: 250px;
}

.esp-tab {
  padding: 20px;
  height: 100%;
}

wfm-plan-loading-overlay {
  background: white;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 50;
}

.loading-error {
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - 180px);
  font-size: larger;
  box-shadow: 0 2px 6px rgba(31, 50, 77, 0.2);
  overflow: hidden;
}

span.err-msg {
  padding: 10px;
}

wfm-task-progress {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

.no-op-hrs,
.no-fte-settings {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: none;
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/plan/ct-settings/ct-settings.component.scss","webpack://./../PSR%20ESP%20WebApp%20Build/src/app/pages/plan/ct-settings/ct-settings.component.scss"],"names":[],"mappings":"AACE;EACE,wBAAA;EACA,0BAAA;EACA,4BAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;ACAJ;;ADGA;EACE,2CAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;ACAF;;ADGA;EACE,cAAA;EACA,2BAAA;EACA,4BAAA;EACA,gBAAA;ACAF;;ADGA;EACE,gBAAA;ACAF;;ADGA;EACE,aAAA;EACA,YAAA;ACAF;;ADGA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;ACAF;;ADGA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iBAAA;EACA,2CAAA;EACA,gBAAA;ACAF;;ADGA;EACE,aAAA;ACAF;;ADEA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;ACCF;;ADEA;;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;ACCF","sourcesContent":[":host ::ng-deep{\n  .settings-title {\n    border-bottom-width: 1px;\n    border-bottom-style: solid;\n    border-bottom-color: #cccccc;\n    padding-bottom: 12px;\n    font-weight: 700;\n    font-size: 16px;\n    margin-bottom: 0px;\n  }\n}\n.toolbar-container{\n  border:1px solid rgba(193, 190, 190, 0.49);\n  justify-content:space-between;\n  align-items:center;\n  padding: 0 10px;\n}\n\ncxone-tabs {\n  display:block;\n  height: calc(100vh - 236px);\n  /*border:1px solid #c1bebe;*/\n  margin-top:16px;\n}\n\np-multiSelect {\n  min-width:250px;\n}\n\n.esp-tab {\n  padding: 20px;\n  height: 100%;\n}\n\nwfm-plan-loading-overlay {\n  background: white;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  z-index: 50;\n}\n\n.loading-error {\n  background: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: calc(100vh - 180px);\n  font-size: larger;\n  box-shadow: 0 2px 6px #1f324d33;\n  overflow: hidden;\n}\n\nspan.err-msg {\n  padding: 10px;\n}\nwfm-task-progress{\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n}\n\n.no-op-hrs,\n.no-fte-settings {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  flex: none;\n  width: 100%;\n  height: 100%;\n}\n",":host ::ng-deep .settings-title {\n  border-bottom-width: 1px;\n  border-bottom-style: solid;\n  border-bottom-color: #cccccc;\n  padding-bottom: 12px;\n  font-weight: 700;\n  font-size: 16px;\n  margin-bottom: 0px;\n}\n\n.toolbar-container {\n  border: 1px solid rgba(193, 190, 190, 0.49);\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 10px;\n}\n\ncxone-tabs {\n  display: block;\n  height: calc(100vh - 236px);\n  /*border:1px solid #c1bebe;*/\n  margin-top: 16px;\n}\n\np-multiSelect {\n  min-width: 250px;\n}\n\n.esp-tab {\n  padding: 20px;\n  height: 100%;\n}\n\nwfm-plan-loading-overlay {\n  background: white;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  z-index: 50;\n}\n\n.loading-error {\n  background: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: calc(100vh - 180px);\n  font-size: larger;\n  box-shadow: 0 2px 6px rgba(31, 50, 77, 0.2);\n  overflow: hidden;\n}\n\nspan.err-msg {\n  padding: 10px;\n}\n\nwfm-task-progress {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n}\n\n.no-op-hrs,\n.no-fte-settings {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  flex: none;\n  width: 100%;\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
